// Legal templates for Step Zone — plain language, subject to legal review.
export const LEGAL_UPDATED = "June 2026";

export const TERMS_SECTIONS = [
  {
    heading: "1. Acceptance of Terms",
    body: "By accessing Step Zone or submitting the form, you agree to these Terms of Service. If you do not agree, please do not use the site or submit information.",
  },
  {
    heading: "2. What Step Zone Does",
    body: "Step Zone is a lead-generation and educational service. You tell us a financial goal (such as lowering expenses, financing, credit, savings, or insurance), and — where you have opted in — we send you relevant information, resources, and available options. Step Zone is not a lender, bank, insurer, credit-repair organization, or financial advisor, and does not make credit or lending decisions.",
  },
  {
    heading: "3. Not Financial Advice",
    body: "Content provided is for general informational purposes only and is not financial, legal, tax, or insurance advice. Always confirm details and suitability with a qualified professional or the relevant provider before making decisions.",
  },
  {
    heading: "4. Accurate Information",
    body: "You agree to provide accurate, current, and complete information. Duplicate submissions using the same phone number or email address may be blocked.",
  },
  {
    heading: "5. Communications Consent",
    body: "We contact you only on the channels you explicitly opt into. If you check the Email box, you consent to marketing emails; if you check the SMS box, you consent to marketing text messages. Each channel is optional and separate. See our SMS Terms and Privacy Policy for details.",
  },
  {
    heading: "6. Acceptable Use",
    body: "You agree not to misuse the site, submit false information, or interfere with its operation. We may remove submissions that appear fraudulent or abusive.",
  },
  {
    heading: "7. Limitation of Liability",
    body: "Step Zone is provided on an 'as is' basis. To the fullest extent permitted by law, we are not liable for indirect or incidental damages arising from your use of the site or reliance on any information provided.",
  },
  {
    heading: "8. Changes to These Terms",
    body: "We may update these Terms from time to time. Continued use of the site after changes take effect constitutes acceptance of the revised Terms.",
  },
  {
    heading: "9. Contact",
    body: "Questions about these Terms can be sent through our Contact page.",
  },
];

export const PRIVACY_SECTIONS = [
  {
    heading: "1. Information We Collect",
    body: "When you use the form, we collect your first and last name, your selected goal, your chosen timeframe, and — depending on the channels you opt into — your email address and/or mobile phone number. We also record consent evidence: which channels you opted into, the date and time, your IP address, a snapshot of the exact consent text you agreed to, and the page you submitted from.",
  },
  {
    heading: "2. How We Use Your Information",
    body: "We use your information to send you the information, resources, and available options you requested on the channels you selected, to prevent duplicate submissions, and to respond to your inquiries. We may share information with vetted partners who can help with your selected goal. We do not sell your personal information.",
  },
  {
    heading: "3. Per-Channel Consent Records",
    body: "We store separate records for email and SMS consent. Each record includes a timestamp, your IP address, the exact consent language you agreed to for that channel, and the submission source URL, as proof that consent was given for that specific channel.",
  },
  {
    heading: "4. Data Storage & Security",
    body: "Your information is stored in a private database accessible only to the Step Zone team. We take reasonable measures to protect your data, though no method of transmission or storage is completely secure.",
  },
  {
    heading: "5. Data Retention",
    body: "We retain submission and consent records for as long as necessary to fulfill the purposes described here or as required by law.",
  },
  {
    heading: "6. Your Choices",
    body: "You may request access to, correction of, or deletion of your information via the Contact page. You can opt out of SMS at any time by replying STOP, and unsubscribe from emails using the link in any email. Opting out of one channel does not affect the other.",
  },
  {
    heading: "7. Changes to This Policy",
    body: "We may update this Privacy Policy periodically. The 'last updated' date above reflects the most recent revision.",
  },
];

export const SMS_SECTIONS = [
  {
    heading: "1. Program Description",
    body: "If you opt into SMS, you agree to receive marketing text messages from Step Zone with financial information, resources, and available options based on the goal you selected.",
  },
  {
    heading: "2. Consent (TCPA)",
    body: "By checking the SMS consent box and providing your mobile number, you consent to receive text messages, including messages sent using automated technology. SMS consent is separate from email consent, and neither is a condition of any purchase.",
  },
  {
    heading: "3. Message Frequency",
    body: "Message frequency varies. You will typically receive occasional messages related to your selected goal.",
  },
  {
    heading: "4. Message & Data Rates",
    body: "Message and data rates may apply depending on your mobile carrier and plan.",
  },
  {
    heading: "5. Opt-Out",
    body: "You can opt out of SMS at any time by replying STOP to any message. After opting out, you'll receive a confirmation and no further texts, unless you re-subscribe. Opting out of SMS does not opt you out of email.",
  },
  {
    heading: "6. Help",
    body: "For help, reply HELP to any message or reach us through the Contact page. Carriers are not liable for delayed or undelivered messages.",
  },
  {
    heading: "7. Privacy",
    body: "Your mobile information is handled according to our Privacy Policy and is not sold to third parties.",
  },
];
